import omit from 'lodash/omit';
import camelCase from 'lodash/camelCase';
import {pluralize} from '../commons/text';

function transformParamsAndAddress(address, params) {
  if (typeof address === 'object' && address.template != null) {
    const values = address.keysToBeOmitted.reduce((acc, value) => {
      acc[value] = params[value];
      return acc;
    }, {});
    let newAddress = address.template(values);
    if (newAddress[newAddress.length - 1] === '/') {
      newAddress = newAddress.slice(0, newAddress.length - 1);
    }
    return [newAddress, omit(params, address.keysToBeOmitted)];
  }

  return [address, params];
}

function url(strings, ...keys) {
  return {
    template: function closure(...values) {
      const dict = values[values.length - 1] || {};
      const result = [strings[0]];
      keys.forEach((key, i) => {
        const value = Number.isInteger(key) ? values[key] : dict[key];
        result.push(value, strings[i + 1]);
      });
      return result.join('');
    },
    keysToBeOmitted: keys,
  };
}

/**
 * This function generates HTTP method function to be used with secure client.
 *
 * @param {Object} params Parameters needed
 * @param {string|object} params.address Target address. Can be string or object containing a template function and required params to form actual address as defined in `url` method above.
 * @param {string} params.method HTTP method.
 * @param {string} params.prefix Address prefix
 * @param {string} params.scope Scope of the API address.
 * @param {string} params.headers HTTP Headers that will be sent.
 */
function generateMethod({address, method = 'get', prefix = '', scope = 'public', headers = {}}) {
  return function send(params = {}, otherOptions = {}) {
    const [addressToBeInvoked, paramsToSend] = transformParamsAndAddress(address, params);

    let options = {
      responseErrorJson: true,
    };

    if (method === 'get') {
      options = {...options, headers, ...otherOptions, params: paramsToSend};
    } else {
      options = {...options, headers, ...otherOptions, data: paramsToSend};
    }

    return this[method](`${prefix}/${addressToBeInvoked}`, scope, options);
  };
}

export function crud(name, address, options = {}) {
  const newAddress = url([`${address}/`], ['id']);

  const factory = (method) =>
    generateMethod({
      address: newAddress,
      method,
      ...options,
    });

  return {
    [pluralize(name)]: factory('get'),
    [camelCase(`get all ${pluralize(name)}`)]: generateMethod({
      address,
      method: 'get',
      ...options,
    }),
    [camelCase(`create ${name}`)]: generateMethod({
      address,
      method: 'post',
      ...options,
    }),
    [camelCase(`update ${name}`)]: factory('put'),
    [camelCase(`delete ${name}`)]: factory('delete'),
  };
}

const invoices = generateMethod({address: url`invoices/${'id'}`, method: 'get'});
const currentUser = generateMethod({address: 'me', method: 'get'});

export {generateMethod, invoices, url, currentUser};
